export const billingAccountDetailsPath = (billingId: string, accountId: string): string => {
	return `/dashboard/active-services/${billingId}/${accountId}/account-details`;
};
